document.addEventListener('DOMContentLoaded', function() {
	const mapItems = document.querySelectorAll('.js-mapItem');
	if (!mapItems.length) return;

	const nlItem = document.querySelector('.js-mapItem.-nl');
	if (!nlItem) return;

	// Create SVG overlay
	const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	Object.assign(svg.style, {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		pointerEvents: 'none',
		overflow: 'visible',
		zIndex: 1
	});
	svg.classList.add('js-mapLines');
	document.body.appendChild(svg);

	const getCenter = (el) => {
		const rect = el.getBoundingClientRect();
		return {
			x: rect.left + rect.width / 2 + window.scrollX,
			y: rect.top + rect.height / 2 + window.scrollY
		};
	};

	function drawArchedLines() {
		svg.innerHTML = ''; // clear old paths
		const nlCenter = getCenter(nlItem);

		mapItems.forEach((item, i) => {
			if (item === nlItem) return;
			const target = getCenter(item);

			// Calculate a midpoint for the arch (control point)
			const dx = target.x - nlCenter.x;
			const dy = target.y - nlCenter.y;
			const curveHeight = -Math.abs(dx) * 0.2;
			const cx = nlCenter.x + dx / 2;
			const cy = nlCenter.y + dy / 2 + curveHeight;

			const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			const d = `M ${nlCenter.x},${nlCenter.y} Q ${cx},${cy} ${target.x},${target.y}`;
			path.setAttribute('d', d);
			path.setAttribute('fill', 'none');
			path.setAttribute('stroke', '#FF7F00');
			path.setAttribute('stroke-width', '2');
			path.setAttribute('stroke-opacity', '1');

			// Animate the path draw
			const length = path.getTotalLength();
			path.style.strokeDasharray = length;
			path.style.strokeDashoffset = length;
			path.style.transition = 'stroke-dashoffset 1.2s ease-out';
			svg.appendChild(path);

			setTimeout(() => {
				path.style.strokeDashoffset = 0;
			}, i * 200);
		});
	}

	drawArchedLines();

	// --- Fix: only redraw if width/height actually changed significantly
	let lastWidth = window.innerWidth;
	let lastHeight = window.innerHeight;
	let resizeTimeout;

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			const widthChanged = Math.abs(window.innerWidth - lastWidth) > 50;
			const heightChanged = Math.abs(window.innerHeight - lastHeight) > 100;

			if (widthChanged || heightChanged) {
				lastWidth = window.innerWidth;
				lastHeight = window.innerHeight;
				drawArchedLines();
			}
		}, 200);
	});
});
